/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { observer } from 'mobx-react';
import React from 'react';
import { QnaMakerContextTreeNode } from 'src/qnaMaker/core/types/QnaMakerContextTreeNode';
import { QnaMakerContextualTreeItem } from 'src/qnaMaker/verticals/qnaMakerQnaContextualTree/components/QnaMakerContextualTreeItem';
import { flattenQnaContextualTree } from 'src/qnaMaker/verticals/qnaMakerQnaContextualTree/qnaMakerContextualTreeUtils';

export type QnaMakerQnaContextualTreeProps = {
    qnaId: number;
    contextTree: QnaMakerContextTreeNode;
    onClickQna: (qnaId: number) => void;
};

export const QnaMakerQnaContextualTree = observer((props: QnaMakerQnaContextualTreeProps) => {
    const { contextTree, qnaId, onClickQna } = props;

    const flattenedTree = React.useMemo(() => flattenQnaContextualTree(contextTree, qnaId), [contextTree]);

    return (
        <Stack tokens={{ childrenGap: 8 }}>
            {flattenedTree.map((node, index) => (
                <QnaMakerContextualTreeItem
                    key={`${index}-${node.id}`}
                    isRoot={index === 0}
                    isCurrentQna={node.qnaId === qnaId}
                    onClick={() => onClickQna(node.qnaId)}
                    {...node}
                />
            ))}
        </Stack>
    );
});
